var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartFreeTrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 386.023,
    height: 279,
    viewBox: "0 0 386.023 279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1169",
    "data-name": "Rectangle 1169",
    width: 375.375,
    height: 264,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1166",
    "data-name": "Rectangle 1166",
    width: 149.915,
    height: 158.406,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1167",
    "data-name": "Rectangle 1167",
    width: 138.942,
    height: 210.282,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-153 -1196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967",
    transform: "translate(163.647 1211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M31.163,1H284.1a30.163,30.163,0,0,1,30.163,30.163V185.377A30.164,30.164,0,0,1,284.1,215.54H31.163A30.163,30.163,0,0,1,1,185.377V31.164A30.162,30.162,0,0,1,31.163,1",
    transform: "translate(-0.138 -0.138)",
    fill: "#f2f2f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1161",
    "data-name": "Rectangle 1161",
    d: "M34.985,0H278.277a34.986,34.986,0,0,1,34.986,34.986V179.554a34.985,34.985,0,0,1-34.985,34.985H34.985A34.985,34.985,0,0,1,0,179.554V34.985A34.985,34.985,0,0,1,34.985,0Z",
    transform: "translate(0.862 0.863)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M31.163,1A30.1,30.1,0,0,0,1,31.164V53.156H314.263V31.164A30.1,30.1,0,0,0,284.1,1Z",
    transform: "translate(-0.138 -0.138)",
    fill: "#ccc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M2.23,219.764a30.067,30.067,0,0,0,29.835,25.929H285a30.066,30.066,0,0,0,29.834-25.929Z",
    transform: "translate(-0.307 -30.292)",
    fill: "#ccc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1162",
    "data-name": "Rectangle 1162",
    d: "M34.985,0H278.277a34.986,34.986,0,0,1,34.986,34.986V179.554a34.985,34.985,0,0,1-34.985,34.985H34.985A34.985,34.985,0,0,1,0,179.554V34.985A34.985,34.985,0,0,1,34.985,0Z",
    transform: "translate(0.862 0.863)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M63.662,83.993a42.791,42.791,0,1,0,42.791,42.791A42.791,42.791,0,0,0,63.662,83.993m0,12.107A13.161,13.161,0,1,1,50.5,109.262,13.161,13.161,0,0,1,63.662,96.1Zm-.029,30.236a26.322,26.322,0,0,1,26.218,24.05H37.473a26.322,26.322,0,0,1,26.16-24.05",
    transform: "translate(-2.877 -11.578)",
    fill: "#fe5e5d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1163",
    "data-name": "Rectangle 1163",
    width: 117.547,
    height: 11.961,
    transform: "translate(118.025 87.18)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1164",
    "data-name": "Rectangle 1164",
    width: 117.547,
    height: 11.961,
    transform: "translate(118.025 109.226)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1165",
    "data-name": "Rectangle 1165",
    width: 117.547,
    height: 11.961,
    transform: "translate(118.025 131.271)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960",
    transform: "translate(164.21 56.996)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_958",
    "data-name": "Group 958",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M322.058,66.108c-49.887,22.213-87.093,18.71-117.823,2.076-22.6,50.729-13.947,118.9,1.407,156.33H310.216a30.1,30.1,0,0,0,30.163-30.163V113.715c-7.5-13.126-13.266-28.649-18.321-47.607",
    transform: "translate(-190.464 -66.108)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M323.231,61.307c-41.415,28.027-75.864,30.986-106.754,21.148-12.03,74.4-1.413,156.571,48.31,189.134,59.374-2.163,110.861-67.036,138.942-136.958C372.2,127.078,344.233,106.726,323.231,61.307Z",
    transform: "translate(-29.216 -8.451)",
    fill: "#4f87fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M323.231,61.307c-41.415,28.027-75.864,30.986-106.754,21.148-12.03,74.4-1.413,156.571,48.31,189.134,59.374-2.163,110.861-67.036,138.942-136.958C372.2,127.078,344.233,106.726,323.231,61.307Z",
    transform: "translate(-29.216 -8.451)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963",
    transform: "translate(235.571 52.856)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M331.678,61.307,273.234,271.588c61.866-1.224,114.243-75.455,138.941-136.958-39.682-11.52-60.16-32.134-80.5-73.323",
    transform: "translate(-273.234 -61.306)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M365.641,147.011a15.176,15.176,0,0,0-11.328,2.1l-61.5,39.843L271.579,155.71a15.253,15.253,0,0,0-20.81-4.762,14.728,14.728,0,0,0-4.668,20.517h0l29.472,46.154.109.135.063.128q.253.305.524.6a15.066,15.066,0,0,0,1.8,2.056c.335.289.682.564,1.041.822a15.169,15.169,0,0,0,1.961,1.318q.63.338,1.288.616a15.32,15.32,0,0,0,2.172.752q.685.191,1.387.318a15.266,15.266,0,0,0,2.38.178c.435.021.871.022,1.306.005a15.24,15.24,0,0,0,2.8-.521c.271-.052.541-.112.808-.179a15.01,15.01,0,0,0,3.17-1.466c.072-.047.144-.1.216-.145l.05-.025,74.337-48.156a14.728,14.728,0,0,0,4.229-20.612,15.232,15.232,0,0,0-9.575-6.435Z",
    transform: "translate(-33.6 -20.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M244.373,19.989a10.013,10.013,0,0,1,10.167,9.852,10.172,10.172,0,0,1-20.333,0,10.013,10.013,0,0,1,10.167-9.852",
    transform: "translate(-32.283 -2.755)",
    fill: "#fe5e5d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M281.6,19.989a10.013,10.013,0,0,1,10.167,9.852,10.172,10.172,0,0,1-20.333,0A10.013,10.013,0,0,1,281.6,19.989",
    transform: "translate(-37.414 -2.755)",
    fill: "#fe5e5d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M318.822,19.989a10.013,10.013,0,0,1,10.167,9.852,10.172,10.172,0,0,1-20.333,0,10.013,10.013,0,0,1,10.167-9.852",
    transform: "translate(-42.545 -2.755)",
    fill: "#fe5e5d",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_969",
    "data-name": "Group 969"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(163 1206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check-circle-fill",
    transform: "translate(153 1196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M55.016,27.508A27.508,27.508,0,1,1,27.508,0,27.508,27.508,0,0,1,55.016,27.508ZM41.365,17.089a2.579,2.579,0,0,0-3.714.076L25.71,32.38l-7.2-7.2a2.579,2.579,0,0,0-3.645,3.645l9.1,9.1a2.579,2.579,0,0,0,3.71-.069L41.4,20.7a2.579,2.579,0,0,0-.034-3.61Z",
    transform: "translate(0 0)",
    fill: "#14c722"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "sparkles-sharp",
    transform: "translate(475.577 1196.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M17.108,70.7,14.1,62.676,6.08,59.668,14.1,56.659l3.008-8.019,3.008,8.019,8.019,3.008-8.019,3.008Z",
    transform: "translate(-5.161 -41.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M5.054,10.109,3.7,6.408,0,5.054,3.7,3.7,5.054,0,6.408,3.7l3.7,1.354-3.7,1.354Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M115.873,25.025l-1.787-4.646-4.646-1.787,4.646-1.787,1.787-4.646,1.787,4.646,4.646,1.787L117.66,20.38Z",
    transform: "translate(-92.899 -10.322)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sparkles-sharp-2",
    "data-name": "sparkles-sharp",
    transform: "translate(324.577 1434.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2195-2",
    "data-name": "Path 2195",
    d: "M17.108,70.7,14.1,62.676,6.08,59.668,14.1,56.659l3.008-8.019,3.008,8.019,8.019,3.008-8.019,3.008Z",
    transform: "translate(-5.161 -41.288)",
    fill: "#adadad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196-2",
    "data-name": "Path 2196",
    d: "M5.054,10.109,3.7,6.408,0,5.054,3.7,3.7,5.054,0,6.408,3.7l3.7,1.354-3.7,1.354Z",
    fill: "#adadad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197-2",
    "data-name": "Path 2197",
    d: "M115.873,25.025l-1.787-4.646-4.646-1.787,4.646-1.787,1.787-4.646,1.787,4.646,4.646,1.787L117.66,20.38Z",
    transform: "translate(-92.899 -10.322)",
    fill: "#adadad"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartFreeTrial);
export default __webpack_public_path__ + "static/media/start-free-trial.2af27caf4c6f89da5d24235e3b2a7623.svg";
export { ForwardRef as ReactComponent };